import React from "react";
import Idahat from "./idahat";
import Sticker from "./sticker";

const shapes = {
  idahat: Idahat,
  sticker: Sticker,
};

const Shape = (props) => {
  const Component = shapes[props.type] || shapes["default"];

  return <Component {...props} />;
};

export default Shape;
